<template>
  <div class="row q-col-gutter-md">
    <div class="col-6 q-col-gutter-md">
        <div class="row q-col-gutter-md">
            <div class="col-6">
                <app-clock-timesheet :currentUser="currentUser"/>
            </div>
            <div class="col-6">
                <app-clock-monthly-total />
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <app-clock-today-summary />
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <app-clock-today-feed />
            </div>
        </div>
    </div>
    <div class="col-6">
        <app-clock-weekly-summary />
    </div>
  </div>
</template>

<script>
import graphql from '@client/graphql';
import AppClockTimesheet from '@client/components/clock-time/clock-timesheet';
import AppClockMonthlyTotal from '@client/components/clock-time/clock-monthy-total';
import AppClockTodaySummary from '@client/components/clock-time/clock-today-summary';
import AppClockTodayFeed from '@client/components/clock-time/clock-today-feed';
import AppClockWeeklySummary from '@client/components/clock-time/clock-weekly-summary';

export default {
  components: {
    AppClockTimesheet,
    AppClockMonthlyTotal,
    AppClockTodaySummary,
    AppClockTodayFeed,
    AppClockWeeklySummary
  },
  name: 'ClockTime',
  metaInfo: {
    title: 'AutoBook Pro - Clock In/Out'
  },
  apollo: {
    currentUser: {
      query: graphql.queries.currentUser,
      watchLoading(isLoading) {
        this.isLoading = isLoading;
      },
      error(error) {
        this.userError = error;
      }
      // result(result) {
      //   // if (result.loading) return;
      // }
    }
  },
  data() {
    return {
      userError: null,
      isLoading: false
    };
  }
};
</script>
<style lang="scss"></style>
